
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/brands/[slug]",
      function () {
        return require("private-next-pages/[locale]/brands/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/brands/[slug]"])
      });
    }
  